/**
 * SSDI subscription tiers — display config aligned with backend pricing.
 */

export const SSDI_PLANS = [
  {
    id: "free",
    name: "Pay Per User",
    tagline: "₹100 per connected user per month",
    price: 100,
    priceLabel: "₹100",
    priceUnit: "per user / month",
    billingNote: "₹100 per connected user per month",
    userLimit: null,
    userLimitLabel: "Unlimited connections",
    perUserPrice: 100,
    perUserLabel: "₹100 per connected user per month",
    accent: "free",
    popular: false,
    features: [
      "Per-user charge",
      "₹100 per user when activated (no free user)",
      "₹100 per connected user per month",
      "Unlimited connections",
      "Connect users on demand",
      "Core CRM access for your company",
    ],
  },
  {
    id: "silver",
    name: "Silver",
    tagline: "Growing teams",
    price: 5000,
    priceLabel: "₹5,000",
    priceUnit: "per month",
    billingNote: "₹5,000/month flat — connect up to 60 users",
    userLimit: 60,
    userLimitLabel: "Up to 60 connected users",
    perUserPrice: null,
    perUserLabel: "Included in monthly plan",
    accent: "silver",
    popular: false,
    features: [
      "Connect up to 60 users",
      "₹5,000 per month flat (no per-user fee)",
      "Scheme stops when 60-user limit is reached",
      "Standard support",
    ],
  },
  {
    id: "golden",
    name: "Golden",
    tagline: "Scale your operations",
    price: 7500,
    priceLabel: "₹7,500",
    priceUnit: "per month",
    billingNote: "₹7,500/month flat — connect up to 100 users",
    userLimit: 100,
    userLimitLabel: "Up to 100 connected users",
    perUserPrice: null,
    perUserLabel: "Included in monthly plan",
    accent: "golden",
    popular: true,
    features: [
      "Connect up to 100 users",
      "₹7,500 per month flat",
      "Scheme stops when 100-user limit is reached",
      "Priority support",
    ],
  },
  {
    id: "platinum",
    name: "Platinum",
    tagline: "Unlimited scale",
    price: 25000,
    priceLabel: "₹25,000",
    priceUnit: "per month",
    billingNote: "₹25,000/month flat — unlimited connected users",
    userLimit: null,
    userLimitLabel: "Unlimited connected users",
    perUserPrice: null,
    perUserLabel: "Unlimited users included",
    accent: "platinum",
    popular: false,
    features: [
      "Unlimited user connections",
      "₹25,000 per month flat",
      "Dedicated account manager",
      "24/7 priority support",
    ],
  },
];

export const PLAN_COMPARISON_ROWS = [
  {
    label: "Monthly fee",
    free: "₹100 / user / month",
    silver: "₹5,000 / month",
    golden: "₹7,500 / month",
    platinum: "₹25,000 / month",
  },
  {
    label: "Per-user connect fee",
    free: "₹100 / user / month",
    silver: "Included",
    golden: "Included",
    platinum: "Included",
  },
  {
    label: "Max connected users",
    free: "Unlimited",
    silver: "60",
    golden: "100",
    platinum: "Unlimited",
  },
  {
    label: "At limit",
    free: "—",
    silver: "Scheme stops — upgrade required",
    golden: "Scheme stops — upgrade required",
    platinum: "—",
  },
];
